const mixpanelEvents = {
  LOGIN: 'Log In',
  LOGOUT: 'Log Out',
  PAGEVIEW: 'Page View',
} as const;

export default mixpanelEvents;
